import { FC } from "react";
import ManageUsers from "features/manageUsers/ManageUsers";
import { useTeamsPurchaseToast } from "hooks/useTeamsPurchaseToast";

const ManageUsersPage: FC = () => {
  useTeamsPurchaseToast();
  return <ManageUsers />;
};

export default ManageUsersPage;
